<template>
  <form @submit.prevent="validarForm">
    <h6 class="text-primary linea2">Personas expuestas públicamente</h6>
    <div class="alert alert-secondary fade show" :class="!valLista && 'alert-danger'" role="alert"
         v-if="validacion>0">
      Debes completar mínimo&nbsp;<b>{{ validacion }}</b>&nbsp;Registro<span
        v-if="validacion>1">s</span>
    </div>
    <div class="pb-2">
      <form class="row" @submit.prevent="validar">
        <div class="form-group col-md-6 col-12">
          <label for="cargo"><i class="fa fa-asterisk text-danger"></i>Cargo</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('cargo') && 'is-invalid'"
              v-model="datos.cargo"
              name="cargo"
              id="cargo"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{errors.first("cargo")}}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label for="entidad"><i class="fa fa-asterisk text-danger"></i>Entidad en la que labora</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('entidad') && 'is-invalid'"
              v-model="datos.entidad"
              name="entidad"
              id="entidad"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{errors.first("entidad")}}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label for="fechadn"><i class="fa fa-asterisk text-danger"></i>Fecha de nombramiento</label>
          <input type="tel" class="form-control"
                 placeholder="dd/mm/yyyy"
                 v-mask="'##/##/####'"
                 v-model="datos.nombramiento"
                 name="fecha de nombramiento"
                 id="fechadn"
                 :class="errors.has('fecha de nombramiento') && 'is-invalid'"
                 v-validate="{required:true,date_format:'dd/MM/yyyy',date_between:[maximaNombramiento,minimaNombramiento,true]}">
          <span class="form-text text-danger">{{errors.first("fecha de nombramiento")}}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label for="fechadc">Fecha de culminación</label>
          <input type="tel" class="form-control"
                 placeholder="dd/mm/yyyy"
                 v-mask="'##/##/####'"
                 v-model="datos.culminacion"
                 name="fecha de culminación"
                 id="fechadc"
                 :class="errors.has('fecha de culminación') && 'is-invalid'"
                 v-validate="{date_format:'dd/MM/yyyy',date_between:[maximaCulminacion,minimaCulminacion,true]}">
          <span class="form-text text-danger">{{errors.first("fecha de culminación")}}</span>
        </div>
        <div class="col-12 col-md-12 p-1">
          <div class="col-12 col-md-4 p-1">
            <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
          </div>
        </div>
      </form>
      <div class="table-responsive pt-2">
        <table class="table table-sm table-striped">
          <thead>
          <tr>
            <th>Cargo</th>
            <th>Entidad</th>
            <th>Fecha de nombramiento</th>
            <th>Fecha de culminación</th>
            <th class="text-center">Acción</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i,ii) in registros" :key="ii" class="animated fadeInDown">
            <td>{{i.dt1}}</td>
            <td>{{i.dt2}}</td>
            <td>{{i.ddt1 | fechaLarga}}</td>
            <td>{{i.ddt2 | fechaLarga}}</td>
            <td class="text-center">
              <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii)" title="Eliminar">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="!registros.length">
            <td colspan="5" class="text-center text-muted">
              No hay elementos agregados<br>
              <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 col-md-12 p-1">
        <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block" :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''" :disabled="cargando">Guardar</button>
      </div>
    </div>
  </form>
</template>

<script>
import constantes from "@/constantes";
import {persona} from "@/servicios";

export default {
  name: "persona-expuesta",
  data: () => ({
    registros:[],
    cargando: false,
    datos:{
      cargo:null,
      entidad:null,
      nombramiento:null,
      culminacion:null,
    }
  }),
  props: {
    validacion: {
      type: Number,
      default: 1
    },
    sync: {
      type: Boolean,
      default: false,
    },
    previos: {
      type: Array
    },
    formulario: {
      type: Object,
      required: true
    },
    tipo: {
      type: Object,
      required: true
    }
  },
  computed:{
    valLista:function(){
      return this.registros.length>=this.validacion;
    },
    minimaCulminacion: function () {
      return this.$moment().format("DD/MM/YYYY");
    },
    maximaCulminacion: function () {
      return this.$moment(this.datos.nombramiento,'DD/MM/YYYY').add(1, "days").format("DD/MM/YYYY");
    },
    minimaNombramiento: function () {
      return this.$moment().add(-1, "month").format("DD/MM/YYYY");
    },
    maximaNombramiento: function () {
      return this.$moment().add(-90, "years").format("DD/MM/YYYY");
    },
  },
  filters:{
    fechaLarga:function(valor){
      if(valor){
        return constantes.funciones.formatoFechaD(valor)
      }else{
        return null;
      }
    }
  },
  methods:{
    validarForm: function () {
        if (this.registros.length>=this.validacion) {
          this.cargando=true;
          this.enviarDatos();
        } else {
          this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
          setTimeout(() => {
            let container = this.$el.querySelector('.alert-danger');
            container.scrollIntoView();
          }, 100);
        }
    },
    validar:function(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          const datos = {
            dt1: this.datos.cargo,
            dt2: this.datos.entidad,
            ddt1: this.$moment(this.datos.nombramiento,'DD/MM/YYYY').toISOString(),
            ddt2: this.datos.culminacion ? this.$moment(this.datos.culminacion,'DD/MM/YYYY').toISOString() : null,
          };
          this.datos = {
            cargo:null,
            entidad:null,
            nombramiento:null,
            culminacion:null,
          };
          this.registros.splice(0, 0, datos);
        } else {
          this.$toast.show(`Completa el formulario de personas expuestas públicamente`);
        }
      });
    },
    enviarDatos:function(){
      persona.actualizacionPersonaExpuesta(this.registros).then(()=>{
        this.cargando=false;
        this.$emit('input',{complete:true,registros:this.registros});
      }).catch(()=>{
        this.cargando=false;
      });
    },
    eliminar:function(index){
      this.registros.splice(index, 1);
    }
  },
  watch: {
    sync: function () {
      this.previos.forEach(
          (e) => {
            this.registros.push(e)
          }
      )
    }
  }
}
</script>

<style scoped>

</style>
